export function sortLocation(a, b) {
    if (a.Primary !== b.Primary) {
        return b.Primary - a.Primary;
    }
    if (a.State !== b.State) {
        return a.State.localeCompare(b.State);
    }
    if (a.City !== b.City) {
        return a.City.localeCompare(b.City);
    }
    return 0;
};

export default {
    sortLocation
};


// WEBPACK FOOTER //
// ./Assets/Scripts/Util/sorts.js